export default __webpack_public_path__ + "static/media/about5title2.41b8582b.png";